module.exports = __webpack_public_path__ + "assets/img/driver-btn-92d1c95e.png";